import { data } from '../../svg/DeleteForever/data';
import { makeIcon } from '../makeIcon';

export const DeleteForever = makeIcon(data, 'delete_forever', 'DeleteForever');

export default DeleteForever;
